<template>
  <div class="layout-app">
    <DigitalExperienceReactApp :permissions="permissions" />
  </div>
</template>

<script setup lang="ts">
import { usePermissions } from '@/hooks/usePermissions';
import DigitalExperienceReactApp from './digitalExperienceShim.vue';

const { permissions } = usePermissions();
</script>
